// extracted by mini-css-extract-plugin
export default {"userCard":"about_userCard__PjBzc"};